<div class="welcome-container">
  <div class="buttons">
    <button (click)="toggleLogin()">{{ 'LOGIN' | translate }}</button>
    <button (click)="openSignupModal()">{{ 'SIGNUP' | translate }}</button>
    <!-- <p-dropdown
    [options]="languages"
    [(ngModel)]="currentLang"
    placeholder="{{ 'LANGUAGE' | translate }}"
    (onChange)="changeLanguage($event.value)">
    <ng-template let-lang pTemplate="selectedItem">
        <i [class]="lang.icon"></i> {{ lang.label | translate }} 
    </ng-template>
    <ng-template let-lang pTemplate="item">
        <i [class]="lang.icon"></i> {{ lang.label | translate }} 
    </ng-template>
</p-dropdown> -->

<p-dropdown
        [options]="languages"
        [ngModel]="currentLang"
        (ngModelChange)="changeLanguage($event)"
        class="lang.sel">
        <ng-template let-lang pTemplate="item">
          <i [class]="lang.icon"></i> {{ lang.label }}
        </ng-template>
      </p-dropdown>
  </div>

  <div class="text-container">
    <h1 class="title">{{ 'WELCOME' | translate }}</h1>
    <p class="subtitle">{{ 'DASHBOARD' | translate }}</p>
  </div>
  <p-toast  position="top-right">a</p-toast>
  <!-- Aquí se muestra el formulario de login si showLogin es true -->
  <div *ngIf="showLogin" id="login-container">
   
    <mat-card class="login-card">  

      <div class="title-container">
      <mat-card-title class="loginTitle"><p id="title-modal">{{'LOGIN_TITLE' | translate}}</p></mat-card-title>
      </div>

      <form (ngSubmit)="iniciarSesion()">
        <mat-card-content>
      
          <div class="p-field mb-20">
            <i class="pi pi-envelope"></i>
            <input id="email" type="email" [(ngModel)]="email" name="email" class="custom-input"
              (input)="quitarEspacios($event.target)" placeholder="{{'EMAIL' | translate}}...">
          </div>
          
          <div class="p-field mb-20">
            <i class="pi pi-lock"></i>
            <input id="password" type="password" [(ngModel)]="password" name="password" class="custom-input"
              #passwordInput placeholder="{{'PASSWORD' | translate}}...">
            <button type="button" class="password-toggle-btn" style="color: #666;"
              (click)="togglePasswordVisibility(passwordInput)">
              <i class="fas" [ngClass]="{'fa-eye-slash': !showPassword, 'fa-eye': showPassword}"></i>
              {{'SHOW_PASSWORD' | translate}}
            </button>
          </div>
        </mat-card-content>
  
        <mat-card-subtitle class="loginSubtitle1">
          {{'FORGOT_PASSWORD' | translate}} 
          <a (click)="openShowRestore()" class="customlink1">
            {{'RESET_HERE' | translate}}
          </a>
          <br>
          <br>
          {{'NO_CUENTA' | translate}}
            <a (click)="openSignupModal()" class="customlink2">{{'SIGNUP' | translate}}</a>
        </mat-card-subtitle>
        
        <mat-card-actions>
          <div class="container-btn-login">
          <button pButton pRipple type="submit" label="{{'LOGIN' | translate}}" class="p-button-rounded loginbutton"></button>
        </div>
        </mat-card-actions>
      </form>
    </mat-card>
  </div>
  

  <!-- Modal de registro -->
  <div class="row signupRow" *ngIf="isSignupModalOpen">
    <mat-card class="signup-card">

      <div class="title-container-s">
        <mat-card-title><p class="signupTitle">{{'CREATE_ACCOUNT' | translate}}</p></mat-card-title>
      </div>


      
      
    <mat-card-subtitle class="loginSubtitle1">{{'ALREADY_HAVE_ACCOUNT' | translate}}<br><a class="customlink2" (click)="toggleLogin()">{{ 'CLICK_HERE_TO_LOGIN' | translate }}</a></mat-card-subtitle>
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <mat-card-content class="mt-20">
        <!-- Campo para el nombre -->
        <div class="p-field1 mb-20" id="signup-div">
          <i class="fas fa-user icon"></i>
          <input type="text" formControlName="name" class="campo" placeholder="{{'NAME' | translate}}..."  pInputText pattern="[A-Za-zÀ-ÿ\s]+"  (keypress)="validateInput($event)" />
           </div>
    
        <!-- Campo para el correo electrónico -->
        <div class="p-field1 mb-20">
          <i class="pi pi-envelope icon"></i>
          <input type="email" formControlName="email" class="campo" placeholder="{{'EMAIL' | translate}}..." pInputText />
        </div>
    
        <!-- Campo para la contraseña -->
        <div class="p-field1 mb-20">
          <i class="pi pi-lock icon"></i>
          <p-password formControlName="password" class="campo" placeholder="{{'PASSWORD'| translate}}..." [toggleMask]="true">
            <ng-template pTemplate="footer">
              <p-divider></p-divider>
              <p class="p-mt-2">Sugerencias</p>
              <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                <li>Al menos una letra minúscula</li>
                <li>Al menos una letra mayúscula</li>
                <li>Al menos un número</li>
                <li>Mínimo 8 caracteres</li>
              </ul>
            </ng-template>
          </p-password>
        </div>
    
        <!-- Campo para confirmar la contraseña -->
        <div class="p-field1 mb-20">
          <i class="pi pi-lock icon"></i>
          <p-password formControlName="confirmPassword" class="campo" placeholder="{{'CONFIRM_PASSWORD' | translate}}..." [toggleMask]="true"></p-password>
        </div>
      </mat-card-content>
    
      <!-- Botón de envío -->
<mat-card-actions>
  <button pButton pRipple type="submit"  label="{{'SIGNUP' | translate}}"class="p-button-raised1 signupbutton"[disabled]="!isFormValid"></button>
</mat-card-actions>
    </form>
    </mat-card>
  
  </div>

  <!-- Modal de Reestablecer contraseña -->
<div class="row restore-pRow" *ngIf="showRestore">
  <mat-card class="restorep-card">
      <!-- Título dentro de mat-card-title -->
      <div class="title-container-r">
          <mat-card-title><p class="restorePTitle">{{'RESTORE_PASS_RESTORE' | translate}}</p></mat-card-title>
      </div>

      <mat-card-content>
          <div class="p-field1 mb-20">
              <i class="pi pi-envelope icon"></i>
              <input [(ngModel)]="email" class="custom-input" placeholder="{{'RESTORE_PASS_EMAIL' | translate}}" />
          </div>

          <!-- Botón con indicador de carga -->
          <button 
              class="custom-button mt-3 restorepbutton" 
              (click)="resetPassword()" 
              [disabled]="loadingApi">
              <ng-container *ngIf="loadingApi; else buttonText">
                  <i class="pi pi-spin pi-spinner"></i> {{'RESTORE_PASS_LOADING' | translate}}
              </ng-container>
              <ng-template #buttonText>{{'RESTORE_PASS_SEND' | translate}}</ng-template>
          </button>

          <!-- Mensaje de confirmación debajo del botón -->
          <p class="confirmation-message">{{'RESTORE_PASS_TEXT_EMAIL' | translate}}</p>
      </mat-card-content>
  </mat-card>
</div>
